const delay = (timer = 0) => new Promise(resolve => {
  setTimeout(resolve, timer);
});
export default delay;